import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {DecimalPipe} from "@angular/common";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import {BatchUpdateRequest} from "../../../../model/api/batch-update-request";
import {CcFormDialogComponent} from "../../../../crystal-elements/form-dialog/cc-form-dialog.component";
import {ProgressTracker} from "../../../../model/api/progress-tracker";
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../model/api/api-validation";
import {
  CustomerAccountTraderDataLoadingService
} from "../../../../services/customer/account-trader/customer-account-trader-data-loading.service";
import {CustomerAccountTraderService} from "../../../../services/customer/account-trader/customer-account-trader.service";
import {AccountTrader} from "../../../../model/customer/account-trader";
import {
  CustomerAccountTraderBatchFormConfigService
} from "../../../../services/customer/account-trader/customer-account-trader-batch-form-config.service";

@Component({
  selector: 'app-batch-action-account-trader-form',
  templateUrl: './batch-action-account-trader-form.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchActionAccountTraderFormComponent extends CcBaseComponent {


  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  @Input()
  formRecord: AccountTrader;
  @Input()
  transPartKey: string;
  @Input()
  selectedRecords: AccountTrader[] = [];
  @Input()
  dialogFormVisible: boolean = false;
  @Input()
  dataLoadingService: CustomerAccountTraderDataLoadingService
  @Input()
  tracker: ProgressTracker
  @Input()
  settingsFormLoadingProgressValue: number = 100;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();

  @Output()
  onSavedForm = new EventEmitter<any>();

  @ViewChild('batchUpdateFormDialog')
  ccFormDialog: CcFormDialogComponent;

  @Input()
  action: "update" | "clone";

  originOwner: string;
  globalInfoMessage: string = '';

  constructor(cdref: ChangeDetectorRef,
              private confirmationService: ConfirmationService,
              private customerAccountTraderService: CustomerAccountTraderService,
              private formConfigService: CustomerAccountTraderBatchFormConfigService,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.formConfig = this.formConfigService.loadConfig(this);
  }

  protected initData(): void {
    super.initData();
  }

  closeDialogForm(): void {
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(false);
    this.markForCheck();
  }

  save() {
    this.formLoading = true;
    const batchUpdateRequest = new BatchUpdateRequest<AccountTrader>();
    batchUpdateRequest.recordToApply = {...this.formRecord}
    batchUpdateRequest.recordIds = this.selectedRecords.map(value => value.id.toString());
    batchUpdateRequest.fieldToUpdate = [...this.formConfigService.fieldsToUpdate];

    this.getSaveAction(batchUpdateRequest).subscribe(validation => {
      if (validation.success) {
        this.formConfigService.fieldsToUpdate.splice(0)
        this.onSavedForm.emit(this.formRecord);
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  private getSaveAction(batchUpdateRequest: BatchUpdateRequest<AccountTrader>): Observable<ApiValidation<any>> {
    if (this.action === "update") {
      return this.customerAccountTraderService.saveBatch(batchUpdateRequest);
    } else if (this.action === "clone") {
      return this.customerAccountTraderService.cloneBatch(batchUpdateRequest);
    } else {
      throw new Error("Unknown action: " + this.action);
    }
  }

  dialogFormVisibleChanged($event: boolean) {
    if ($event) {
      this.originOwner = this.formRecord.owner;
      this.globalInfoMessage = '';
      this.formConfig = this.formConfigService.loadConfig(this);
    }

    this.dialogFormTitle = $event ? this.getTranslation('page.' + this.transPartKey + '.table.batch_' + this.action + '_button')
      + " " + this.selectedRecords.length + " " + this.getTranslation('page.' + this.transPartKey + '.item_name') + 's' : '';

    this.dialogFormVisibleChange.emit($event);
    this.formConfigService.fieldsToUpdate.splice(0);
    this.ccFormDialog.reloadFieldValueMap();
    setTimeout(() =>{
      this.formLoading = !$event;
      this.markForCheck();
    });
  }

  public confirmDialog(
    action: () => void,
    titleKey: string,
    messageKey: string,
    submitKey = 'common.dialog.ok',
    cancelKey = 'common.dialog.cancel',
  ): void {
    this.confirmationService.confirm({
      header: this.getTranslation(titleKey),
      message:
        this.getTranslation(messageKey),
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: this.getTranslation(submitKey),
      rejectLabel: this.getTranslation(cancelKey),
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => action(),
    });
  }

}
